import { useEffect } from "react"
import DataGrid from "../genericGrid";
import SearchIcon from '@mui/icons-material/Search';

const SelectionSideScreen = ({ data, setHeader, notifyParent, close }) => {
    const onSelected = (item) => {
        notifyParent(item);
        close();
    }    
    useEffect(() => {
        setHeader({icon:SearchIcon, text:"Select Side Screen"});
    }, [setHeader])
    return (
        <DataGrid onClick={onSelected} forceMobile type={data.type + "s"} />
    )
}
export default SelectionSideScreen;